<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="80px"
                        class="demo-ruleForm"
                    >
                        <el-form-item label="分析组别" prop="locationCode">
                            <el-col :span="22">
                                <el-select
                                    v-model="value"
                                    filterable
                                    placeholder="试一试搜索:类型"
                                    @change="handleChange2"
                                    size="large"
                                    style="width : 350px"
                                >
                                    <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >确认</el-button
                            >
                            <el-button @click="cancel">返回</el-button>
                            <el-button
                                @click="downLoad2('券号状态')"
                                type="success"
                                >下载表格</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" :lg="24" :sm="24" :md="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="加载中"
                        :data="tableData"
                        style="width: 100%"
                        border
                        
                    >
                    <el-table-column
                            :label="labelTitle"
                            prop="loc"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <!-- <el-table-column
                            :label="labelShop"
                            prop="productName"
                            align="left"
                            header-align="center"
                            v-if="isShopType"
                            width="100"
                        >
                        </el-table-column> -->

                        <el-table-column
                            label="类型"
                            prop="productName"
                            align="left"
                            header-align="center"
                            v-if="isProd"
                            width="100"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="totalG"
                            :label="shop.type1"
                            v-if="isTypes"
                            align="right"
                            header-align="center"
                            
                        >
                        </el-table-column>
                        <el-table-column
                            :label="shop.type2"
                            v-if="isTypes"
                            align="right"
                            header-align="center"
                            
                        >
                            <el-table-column
                                :label="shop.type3"
                                align="right"
                                header-align="center"
                                prop="totalG"
                                
                            >
                                <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.countG
                                        }}<span class="colorWhite">/</span>
                                    </p>
                                    <p>{{ scope.row.totalC }}</p>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            :label="shop.type4"
                            v-if="isTypes"
                            align="right"
                            header-align="center"
                            
                        >
                            <el-table-column
                                label="已分配"
                                align="right"
                                header-align="center"
                                prop="totalD"
                                
                            >
                    

                                <!-- <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.countC
                                        }}<span class="colorWhite">/</span>
                                         <el-button v-if="showVoucerVo" @click="handleClick(scope.row,'D')" type="text" size="small">查看券号</el-button>
                                    </p>
                                    <p>{{ scope.row.totalD }}</p>
                                </template> -->
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            prop="totalD"
                            label="已分配"
                            v-if="!isTypes"
                            align="right"
                            header-align="center"
                            
                        >
                        <!-- <template slot-scope="scope">
                            <p>{{ scope.row.totalD }}</p>
                            <el-button v-if="showVoucerVo" @click="handleClick(scope.row,'D')" type="text" size="small">查看券号</el-button>
                        </template> -->
                        </el-table-column>
                        <el-table-column
                            label="未激活"
                            align="right"
                            header-align="center"
                            
                        >
                            <el-table-column
                                label="已激活"
                                align="right"
                                header-align="center"
                                prop="totalD"
                                
                            >
                                <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.countD
                                        }}<span class="colorWhite">/</span>
                                        <el-button v-if="showVoucerVo" @click="handleClick(scope.row,'D')" type="text" size="small">查看券号</el-button>
                                    </p>
                                    <p>{{ scope.row.totalA }}</p>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            label="未销售"
                            align="right"
                            header-align="center"
                            
                        >
                            <el-table-column
                                label="已销售"
                                align="right"
                                header-align="center"
                                prop="totalA"
                                
                            >
                                <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.countA
                                        }}<span class="colorWhite">/</span>
                                        <el-button v-if="showVoucerVo" @click="handleClick(scope.row,'A')" type="text" size="small">查看券号</el-button>
                                    </p>
                                    <p>{{ scope.row.totalS }}</p>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            label="未核销"
                            align="right"
                            header-align="center"
                            
                        >
                            <el-table-column
                                label="已核销"
                                align="right"
                                header-align="center"
                                prop="totalS"
                                
                            >
                           
                                <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.countS
                                        }}<span class="colorWhite">/</span>
                                        <el-button v-if="showVoucerVo" @click="handleClick(scope.row,'S')" type="text" size="small">查看券号</el-button>
                                    </p>
      
                                    <p>{{ scope.row.totalR }}</p>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-dialog title="券号" :visible.sync="outerVisible" center >
                <div v-html="vmsNo"></div>
            </el-dialog>
        </el-card>
    </div>
</template>
<style lang="less">
.colorWhite {
    color: white;
}
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins: [requestMixin, common],
    data () {
        return {
            outerVisible:false,
            isProd: false,
            vmsNo:'',
            showVoucerVo:false,
            ruleForm: {
                locationCode: '',
            },
            rules: {
                locationCode: [
                    { required: true, message: '请填写地点名称', trigger: 'blur' },
                ],
            },
            options2: [
                {
                    value: 'statusByType',
                    label: '类型'
                },
                {
                    value: 'statusByShop',
                    label: '店铺'
                },
                {
                    value: 'statusByDistrict',
                    label: '地区'
                },
                {
                    value: 'statusByBrand',
                    label: '品牌'
                },
                {
                    value: 'statusByShopType',
                    label: '店铺+类型'
                }
            ],
            value: '',
            loading: false,
            tableData: [
                // {
                //     loc : '',
                //     countG: '',
                //     countC: '',
                //     countD: '',
                //     countA: '',
                //     countS: '',
                //     countR: '',
                // }
            ],
            shop: {
                type1: '已生成',
                type2: '未确认',
                type3: '已确认',
                type4: "未分配"
            },
            isTypes: true,
            labelTitle: '类型',
            labelShop: '类型',
            isShopType: false
        }

    },
    created () {

    },
    mounted () {
    
        this.handleChange2('statusByShop')
    },
    methods: {
        handleClick(row,status){
            let param={
                "act":"findVoucherVoByTypeAndLocation",
                "status":status,
                "locationCode":row.locCode,
                "typeCode":row.typeCode,
                "userId":sessionStorage.getItem("userId")
            }
            debugger
         this.delType(param).then((res)=>{
            if (res.data.status == true){
                this.vmsNo = res.data.voucherVo=='null'?'暂无券号信息':res.data.voucherVo;
                let newStr = this.vmsNo.replace(/,/g, "&nbsp;&nbsp;");
                this.vmsNo=newStr;
                this.outerVisible = true;
            }
         })
        },
        //下载表格
        downLoad2 (name) {
            this.debounce(this.downLoad(name), 2000);
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //console.log(this.ruleForm)
                    let { locationCode, date } = this.ruleForm;
                    let userId = sessionStorage.getItem('userId');
                    locationCode = this.trim(locationCode)
                    let params = {
                        act: `${locationCode}`,
                        userId
                    }
                    this.getReports(params);
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel () {
            this.$router.go(-1)
        },
        //动态分类组别的act
        handleChange2 (value) {
            this.isProd=false;
            this.showVoucerVo=false;
            this.isShopType = false;
            value = this.trim(value)
            this.ruleForm.locationCode = value;
            this.isTypes = true;
            let titleObj = this.options2.find(elem => {
                return elem.value == value
            })
            titleObj = titleObj.label;
            this.labelTitle = titleObj;
            this.isShopType = false;
            
            // console.log(titleObj)
            if (value == 'statusByType') {
                // console.log('显示全')
                this.isTypes = true;
                this.showVoucerVo=false;
                this.isShopType = false;
                this.shop = {
                    type1: '已生成',
                    type2: '未确认',
                    type3: '已确认',
                    type4: "未分配"
                },
                    this.tableData = [];
            } else if (value == 'statusByShop' || value == "statusByDistrict" || value == "statusByBrand" 
            ) {
            
              
            
                this.isTypes = false;
                this.isShopType = false;
                this.shop = {}
                this.tableData = [];
               
               
            } else if (value == "statusByShopType") {
              
                this.labelTitle = '店铺'
                this.labelShop='类型';
                this.isShopType = false;

                this.isProd=true;
                this.showVoucerVo=true;
                this.shop = {}
                this.tableData = [];

                this.isTypes = false;
               
             }else{
                this.showVoucerVo=false;
                this.isTypes = true;
                this.isShopType = false;
                this.shop = {
                    type1: '已生成',
                    type2: '未确认',
                    type3: '已确认',
                    type4: "未分配"
                },
                this.tableData = [];
            }

        },
      //请求结算报表
        getReports (params) {
            let {userId,act} = params;
            this.loading = true;
            this.delType(params).then((res) => {
                // console.log(res)
                let { status, report } = res.data;
                if (status == true) {
                    //this.sortChinese(report,'loc')
                    this.loading = false;
                    report.shift();
                    //let reportObj = report ;
                    // report.forEach((elem) =>{
                    //     console.log(elem)
                    //     elem.totleCountC = elem.countG+elem.totalC
                    // })
                    
                    let reportObj = report.filter((elel, i) => i % 2 == 0);
                    let reportObjTotal = report.filter((elem, i) => i % 2 !== 0)
                    var reg = /(?=(?!\b)(\d{3})+$)/g;
                    reportObj.forEach((elem, i) => {
                        elem.countA = this.changeTree(elem.countA);
                        elem.countC = this.changeTree(elem.countC);
                        elem.countD = this.changeTree(elem.countD);
                        elem.countG = this.changeTree(elem.countG);
                        elem.countR = this.changeTree(elem.countR);
                        elem.countS = this.changeTree(elem.countS);


                        // elem.countA = this.changeTree(elem.countA) ;
                        // elem.countC = this.changeTree(elem.countC) ;
                        // elem.countD = this.changeTree(elem.countD) ;
                        // elem.countG = this.changeTree(elem.countG) ;
                        // elem.countR = this.changeTree(elem.countR) ;
                        // elem.countS = this.changeTree(elem.countS);
                        reportObjTotal.forEach((elem1, i1) => {
                            if(act="statusByShopType"){
                                if (elem1.loc == elem.loc&&elem1.productName==elem.productName) {
                                // console.log(elem1.loc)
                                // console.log(elem1)
                                // console.log(elem.countG.replace(/,/g, ""))
                                // console.log(elem.totalC.replace(/,/g, ""))
                                // // if(){

                                // // }
                                // elem.totalCountC = (elem.countG).replace(/,/g, "") + (elem1.totalC).replace(/,/g, "");
                                // console.log(elem1.totalCountC)
                                elem.totalA = this.changeTree(elem1.totalA);
                                elem.totalC = this.changeTree(elem1.totalC);
                                elem.totalD = this.changeTree(elem1.totalD);
                                elem.totalG = this.changeTree(elem1.totalG);
                                elem.totalR = this.changeTree(elem1.totalR);
                                elem.totalS = this.changeTree(elem1.totalS);
                            }
                            }else{
                                if (elem1.loc == elem.loc) {
                                // console.log(elem1.loc)
                                // console.log(elem1)
                                // console.log(elem.countG.replace(/,/g, ""))
                                // console.log(elem.totalC.replace(/,/g, ""))
                                // // if(){

                                // // }
                                // elem.totalCountC = (elem.countG).replace(/,/g, "") + (elem1.totalC).replace(/,/g, "");
                                // console.log(elem1.totalCountC)
                                elem.totalA = this.changeTree(elem1.totalA);
                                elem.totalC = this.changeTree(elem1.totalC);
                                elem.totalD = this.changeTree(elem1.totalD);
                                elem.totalG = this.changeTree(elem1.totalG);
                                elem.totalR = this.changeTree(elem1.totalR);
                                elem.totalS = this.changeTree(elem1.totalS);
                            }
                            }
                           
                        })
                    })
                    // console.log(reportObj)
                    let act = params.act;
                    if (act == 'statusByType') {
                        let params = {
                            act: 'findTypes',
                            userId
                        }
                        this.formalName(reportObj, "typeCode", params)
                    } else if (act == 'statusByShop' || act == 'statusByDistrict' || act == 'statusByBrand') {
                        let params = {
                            act: 'findLocations',
                            userId
                        }
                        this.formalName(reportObj, "locationCode", params)
                    }
                    
                    this.tableData = reportObj;
                    console.log(this.tableData)
                } else {
                    this.loading = false;
                    this.alert('查找失败!', 'warning')
                }
            })
        },

        //券号类型改为券号名称
        formalName (arr, typeCode, params) {
            this.delType(params).then(res => {
                // console.log(res)
                //debugger
                let { status, list } = res.data;
                var re = /(?=(?!\b)(\d{3})+$)/g;
                if (status == true) {
                    list.forEach((elem => {
                        arr.forEach(elem1 => {
                            if (elem1.loc == elem[typeCode]) {
                                elem1.loc = elem.description;
                            }
                            if (elem1.loc == elem[typeCode].slice(0, 2)) {
                                elem1.loc = elem.description.slice(0, 2)
                            }
                            if (elem1.loc == elem[typeCode].slice(2, 4)) {
                                let des = elem.description.split('-')[1];
                                if (des) {
                                    elem1.loc = elem.description.split('-')[1]
                                } else {
                                    elem1.loc = elem.description;
                                }
                            }
                        });
                    }))
                } else {
                    this.promptMsg('加载失败', 'info')
                }
            })
        },
        // 总计最后一行
        getSummaries (param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = data.map(item => {
                    // console.log(item)
                    // console.log(item[column.property])
                    if (typeof item[column.property] == "string") {
                        return Number(item[column.property].replace(/,/g, ""))
                    }
                });
                // console.log(values)
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },

        objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                // console.log(rowIndex)
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            // if (columnIndex === 1) {
            //     if (rowIndex % 2 === 0) {
            //         return {
            //             rowspan: 2,
            //             colspan: 1
            //         };
            //     } else {
            //         return {
            //             rowspan: 0,
            //             colspan: 0
            //         };
            //     }
            // }
        },
    }
}
</script>
